<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.02</b> - Armor class revamp!</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Armor Class now works as a % damage reduction, not flat</li>
      <li>Removed the Pixie Dust cost for resetting abilities & attributes</li>
      <li>Caverns info panel: added loot items to the legend, blurb about auto-pickup</li>
      <li>Nerfed Multi-shot damage</li>
      <li>Reduced gold rewards for Inn battles</li>
      <li>Fixed a bug resizing the game window from the Shop</li>
      <li>(And, as usual, several other bug fixes not worth mentioning.)</li>
    </ul>
  </div>
</template>
